export class SmsStudent {
  id = ''
  name = ''
  phone = ''
  parent = {
    phone: '',
  }

  constructor(data) {
    this.id = data.id
    this.name = data.name
    this.phone = data.phone
    this.parent = data.parent
  }
}
